(function () {
  function bindThumb(modal) {
    var variantSelection = modal.querySelector('[data-variant-selection]');
    var thumb = modal.querySelector('[data-quickshop-thumb]');
    if (!variantSelection || !thumb || variantSelection.dataset.quickshopThumbBound) return;

    variantSelection.dataset.quickshopThumbBound = 'true';
    variantSelection.addEventListener('variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || !variant.featured_image) return;

      thumb.src = variant.featured_image.src;
      thumb.srcset = '';
      if (variant.featured_image.alt) {
        thumb.alt = variant.featured_image.alt;
      }
    });
  }

  function hydrateQuickshopRating() {
    var modalRoot =
      document.querySelector('.modal--quickshop .modal-content, .modal--quickshop [data-modal-content], .modal--quickshop') ||
      document.querySelector('.quickshop-modal');

    if (!modalRoot) return false;

    modalRoot.querySelectorAll('.quickshop-modal').forEach(bindThumb);

    if (window.VoyagerProductCardRatings && typeof window.VoyagerProductCardRatings.hydrateQuickshop === 'function') {
      window.VoyagerProductCardRatings.hydrateQuickshop(modalRoot);
    } else if (window.VoyagerProductCardRatings && typeof window.VoyagerProductCardRatings.format === 'function') {
      window.VoyagerProductCardRatings.format(modalRoot);
    }

    var rating = modalRoot.querySelector('.quickshop-modal__rating--yotpo');
    if (!rating) return true;
    if (rating.classList.contains('voyager-yotpo-rating--empty')) return true;
    return rating.getAttribute('data-voyager-rating-hydrated') === 'true' ||
      rating.classList.contains('voyager-yotpo-rating--ready');
  }

  function scheduleModalRatingHydrate() {
    // Few gentle retries only — never call initWidgets on the whole page
    var delays = [80, 400, 1200];
    delays.forEach(function (delay) {
      window.setTimeout(function () {
        if (hydrateQuickshopRating()) return;
      }, delay);
    });
  }

  function patchModal() {
    if (!window.modal || window.modal.__quickshopThumbPatched) return;

    var originalUpdateContent = window.modal.updateContent.bind(window.modal);
    window.modal.updateContent = function (content) {
      originalUpdateContent(content);
      scheduleModalRatingHydrate();
    };

    window.modal.__quickshopThumbPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchModal);
  } else {
    patchModal();
  }

  var waitForModal = window.setInterval(function () {
    if (window.modal) {
      patchModal();
      window.clearInterval(waitForModal);
    }
  }, 50);
})();
